// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p0-0";
export var buttonContainer = "_p0-3";
export var cancelButton = "_p0-4";
export var headerSection = "_p0-6";
export var headerTitle = "_p0-9";
export var messageSideLeft = "_p0-1";
export var messageSideRight = "_p0-2";
export var orderNumberContainer = "_p0-7";
export var orderNumberLabel = "_p0-8";
export var submitButton = "_p0-5";